import React, { useContext } from "react";
import {
  Alpha1Set,
  Alpha2Set,
  Cesium1Set,
  RendouSet,
  ModeSet,
  MetadataSet,
  Area1Set,
  Area2Set,
} from "../App";
import { SyukurenSet } from "../App";
import {
  Rotate1Set,
  Rotate2Set,
  Zoomhanrei1Set,
  Zoomlevel1Set,
  Zoomlevel2Set,
  Static2Map1Set,
  Static2Map2Set,
} from "../App";
import { useEffect } from "react";
import {
  Cartesian3,
  Entity as cesiumEntity,
  HeadingPitchRange,
  ScreenSpaceEventHandler,
  ScreenSpaceEventType,
  Math as Cesium_Math,
  BoundingSphere,
  EasingFunction
} from "cesium";

export const FunkClickFlyto = ({ rfcs, defratio, valratio }) => {
  // 左クリックでデータの位置まで移動する機能 //////////////
  const { rendouset, setRendouSet } = useContext(RendouSet);
  const { zoomlevel1set, setZoomlevel1Set } = useContext(Zoomlevel1Set);
  const { zoomlevel2set, setZoomlevel2Set } = useContext(Zoomlevel2Set);
  const { zoomhanrei1set, setZoomhanrei1Set } = useContext(Zoomhanrei1Set);
  const { rotate1set, setRotate1Set } = useContext(Rotate1Set);
  const { rotate2set, setRotate2Set } = useContext(Rotate2Set);

  const { modeset, setModeSet } = useContext(ModeSet);

  // const { alpha1set,setAlpha1Set} = useContext(Alpha1Set)
  // const { alpha2set,setAlpha2Set} = useContext(Alpha2Set)

  const { static2map1set, setStatic2Map1Set } = useContext(Static2Map1Set);
  const { static2map2set, setStatic2Map2Set } = useContext(Static2Map2Set);

  const { area1set, setArea1Set } = useContext(Area1Set);
  const { area2set, setArea2Set } = useContext(Area2Set);

  useEffect(() => {
    rfcs.current.cesiumElement.camera.cancelFlight();
  }, [rotate1set, rotate2set]);

  useEffect(() => {
    window.setTimeout(function () {
      if (rfcs.current && rfcs.current.cesiumElement && static2map1set) {
        let viewer = rfcs.current.cesiumElement;
        var handler = new ScreenSpaceEventHandler(viewer.scene.canvas);
        handler.setInputAction(function (e) {
          viewer.trackedEntity = undefined;
          setRotate1Set(false);
          setRotate2Set(false);

          const flytozoom = () => {
            setZoomhanrei1Set(pickedarr);
            setZoomlevel1Set(4);
            // setAlpha1Set(0)
            // setAlpha2Set(0)
            if (rendouset) {
              setZoomlevel2Set(4);
            }

            let zoomheight = 1200;
            if (modeset == 5) {
              if (
                currentbarheight * defratio.kokudo_ratio * valratio >
                1200 * 10
              ) {
                zoomheight = 1200 * 10;
              } else {
                zoomheight =
                  currentbarheight * defratio.kokudo_ratio * valratio * 0.9;
              }
            } else {
              if (currentbarheight * defratio.ratio * valratio > 1200) {
                zoomheight = 1200;
              } else {
                zoomheight = currentbarheight * defratio.ratio * valratio * 0.9;
              }
            }

            viewer.camera.flyTo({
              destination: Cartesian3.fromDegrees(lat, lon, zoomheight),
              orientation: {
                heading: Cesium_Math.toRadians(0),
                pitch: Cesium_Math.toRadians(-90),
                roll: 0.0,
              },
              duration: 0.7,
              // complete: hanreichange
            });
          };
          // const hanreichange = () => {
          //   setZoomhanrei1Set(pickedarr);
          //   setZoomlevel1Set(4);
          //   if (rendouset) {
          //     setZoomlevel2Set(4);
          //   }
          // }

          var picked = viewer.scene.pick(e.position);
          // console.log(picked);
          if (picked) {
            var pickedchara = String(picked.id._name);
            var pickedarr = pickedchara.split(",");
            // console.log(pickedarr);
            var lat = Number(pickedarr[0]);
            var lon = Number(pickedarr[1]);
            var meshcode = Number(pickedarr[2]);
            var currentbarheight = Number(pickedarr[3]);
            var currentheight = viewer.camera._positionCartographic.height;
            viewer.camera.flyTo({
              destination: Cartesian3.fromDegrees(
                lat,
                lon,
                currentheight * 0.7
              ),
              orientation: {
                heading: Cesium_Math.toRadians(0),
                pitch: Cesium_Math.toRadians(-90),
                roll: 0.0,
              },
              // duration: 1,
              complete: flytozoom,
            });

            // console.log(viewer.camera);

            // if(viewer.camera.)

            // setTimeout(() => {
            //   viewer.camera.cancelFlight();
            // }, 1000);

            // setTimeout(() => {
            //   viewer.camera.flyTo({
            //     destination: Cartesian3.fromDegrees(lat, lon, currentbarheight>1200 ? 1200 : currentbarheight*0.9),
            //     orientation: {
            //       heading: Cesium_Math.toRadians(0),
            //       pitch: Cesium_Math.toRadians(-90),
            //       roll: 0.0,
            //     },
            //   });
            // }, 2000);

            // setZoomCount(pickedarr)
            // setTimeout(function () {
            //   setZoomhanrei1Set(pickedarr);
            //   setZoomlevel1Set(4);
            //   if (rendouset) {
            //     setZoomlevel2Set(4);
            //   }
            //   // picked.id.entityCollection.show = false;
            //   // picked.id.entityCollection.show = false;
            // }, 4000);
          } else {
            // viewer.entities.show = true;
            // setZoomlevel1Set(1);
            if (rendouset) {
              // setZoomlevel2Set(1);
            }


            // console.log(modeset);
            // console.log(defratio.tenkei_height);
            // console.log(defratio.tenkei_lon);
            // console.log(defratio.tenkei_lat);
            // console.log(defratio.tenkei_heading);
            // console.log(defratio.tenkei_pitch);
            // console.log(defratio.tenkei_roll);
            // console.log(defratio);
            // console.log(valratio);



            // if (
            //   modeset == defratio.tenkei_mode &&
            //   area1set == defratio.tenkei_city
            // ) {
            //   viewer.flyTo(
            //     viewer.entities,
            //     new HeadingPitchRange(0, -1, 500000000)
            //   );
            //   setZoomlevel1Set(1);
            //   setZoomhanrei1Set(null);
            //   console.log("発動１");
            // } else if (
            //   modeset == defratio.tenkei_mode &&
            //   area2set == defratio.tenkei_city
            // ) {
            //   viewer.flyTo(
            //     viewer.entities,
            //     new HeadingPitchRange(0, -1, 500000000)
            //   );
            //   setZoomlevel1Set(1);
            //   setZoomhanrei1Set(null);
            //   console.log("発動１");
            // } else {

            viewer.flyTo(
                viewer.entities,
                new HeadingPitchRange(0, -1, 50000)
              );

              setZoomlevel1Set(1);
              setZoomhanrei1Set(null);
              // console.log("発動２");
            }
          // }
        }, ScreenSpaceEventType.LEFT_CLICK);
        // }, ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
        // console.log("ダブルクリックでズームする機能");

        // // 左クリックで緯度経度を取得する処理（動作しますが重いので一旦外してます）
        //     rfcs.current.cesiumElement.canvas.addEventListener('click',
        //     function(e) {
        //       if(modeset == 2 || modeset == 3){
        //         var mousePosition = new Cartesian2(e.clientX - rfcs.current.cesiumElement.canvas.width, e.clientY);
        //       } else {
        //         var mousePosition = new Cartesian2(e.clientX, e.clientY);
        //       }
        //         var ellipsoid = rfcs.current.cesiumElement.scene.globe.ellipsoid;
        //         var cartesian = rfcs.current.cesiumElement.camera.pickEllipsoid(mousePosition, ellipsoid);
        //         if (cartesian) {
        //             //位置情報を管理するオブジェクトcartographicを取得
        //             var cartographic = Cartographic.fromCartesian(cartesian);
        //             //緯度経度を小数点5桁で取得
        //             var lon = Cesium_Math.toDegrees(cartographic.longitude);
        //             var lat = Cesium_Math.toDegrees(cartographic.latitude);

        //         }
        //         // console.log(lon);
        //         // console.log(lat);
        //         var mesh1 = calcMeshCode(lon, lat, 3)
        //         // console.log(mesh1);
        //     }, false
        // );
      }
    }, 0);
  }, [static2map1set, static2map2set, modeset, area1set, area2set]);

  return <></>;
};
